import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive Spinner (server)
 * ROLE: none — aria-hidden="true"; purely decorative SVG animation
 * KEYBOARD: non-focusable (no tabIndex, no role)
 * FOCUS: none — zero focus management; SSR-safe
 * LIVE-REGION: none — parent MUST set aria-busy="true" on the region so AT
 *   receives a loading signal. <Spinner> alone gives SR users no feedback.
 * PRM: opacity pulse instead of rotate (prefers-reduced-motion: reduce)
 * FORCED-COLORS: stroke inherits ButtonText so the arc remains visible
 * RTL: direction-agnostic
 * RSC: SERVER
 */
import styles from './Spinner.module.css';
// Stroke geometry for a 24×24 viewBox, r=10 centred at (12,12).
// Circumference = 2π×10 ≈ 62.83. Arc ≈ 25% ≈ 15.71; gap = remainder.
const ARC = 15.71;
const GAP = 47.12;
const SIZE_PX = { sm: 16, md: 24, lg: 40 };
export function Spinner({ size = 'md', className }) {
    const px = SIZE_PX[size];
    const rootClass = [styles.spinner, className].filter(Boolean).join(' ');
    return (_jsxs("svg", { width: px, height: px, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", className: rootClass, children: [_jsx("circle", { cx: "12", cy: "12", r: "10", stroke: "var(--muted)", strokeWidth: "2.5" }), _jsx("circle", { cx: "12", cy: "12", r: "10", stroke: "var(--primary)", strokeWidth: "2.5", strokeLinecap: "round", strokeDasharray: `${ARC} ${GAP}`, className: styles.arc })] }));
}
//# sourceMappingURL=Spinner.js.map